import React from "react";
import { Route, Routes } from "react-router-dom";
import Dashboard from "../Pages/Dashboard";
import Situation from "../Pages/Situation";
import Documents from "../Pages/Documents";
import Familles from "../Pages/Familles";
import FournisseursSoins from "../Pages/FournisseursSoins";
import Contacts from "../Pages/Contacts";
import Profil from "../Pages/Profil";
import TextReglement from "../Pages/TextReglement";


export default function AppRoutes() {
  return (
    <div>
      <Routes>
        
        <Route path="/" element={<Dashboard />}></Route>
        <Route path="/dashboard" element={<Dashboard />}></Route>
        <Route path="/situation" element={<Situation />}></Route>
        <Route path="/documents" element={<Documents />}></Route>
        <Route path="/famille" element={<Familles />}></Route>
        <Route path="/fournisseurs_soins" element={<FournisseursSoins />}></Route>
        <Route path="/contact" element={<Contacts />}></Route>
        <Route path="/profil" element={<Profil />}></Route>
        <Route path="/textes_reglement" element={<TextReglement />}></Route>
      </Routes>
    </div>
  );
}


